export default __webpack_public_path__ + "static/media/logo.f0c14c26.svg";